import instance from '../../../api/axios'
import { AuthUser, LoginData } from '../types/users'

export const authUser = async (): Promise<AuthUser | undefined> => {
  const response = await instance.get('/users/auth')
  return response.data
}

export const loginUser = async (
  loginData: LoginData,
): Promise<AuthUser | undefined> => {
  const response = await instance.post('/users/login', loginData)
  const payload = response.data as (AuthUser & { token?: string }) | undefined

  if (!payload) {
    return undefined
  }

  const user = { ...payload }
  delete user.token
  return user
}

export const logoutUser = async (): Promise<boolean> => {
  const response = await instance.post('/users/logout', {})
  return Boolean(response.data)
}

export const updateOwnPrivateMode = async (payload: {
  isPrivateModeActive: boolean
  modules: AuthUser['modules']
}): Promise<AuthUser> => {
  const response = await instance.put('/users/private-mode', payload)
  return response.data
}
